import React, { useState } from "react";
import { Modal, Timeline, Form, Row, Col, notification } from "antd";
import liracrypt from "../Liracrypt/liracrypt";
import moment from "moment";

const dummyData = [
  {
    dt: "2015-09-01 09:12:11",
    rmrk: "Create a services",
  },
  {
    dt: "2015-09-01 10:32:11",
    rmrk: "Solve initial network problems",
  },
  {
    dt: "2015-09-01 13:45:11",
    rmrk: "Technical testing",
  },
  {
    dt: "2015-09-01 17:11:11",
    rmrk: "Network problems being solved",
  },
];

function TimeLinePopUp({ visible, setVisible, rowData }) {
  const [form] = Form.useForm();

  const [timelineData, setTimelineData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: msg,
    });
  };

  React.useEffect(() => {
    liracrypt
      .get("/textapi", { ...rowData, dn: "TimelineModal" })
      .then((res, req) => {
        
        setTimelineData(res.data.data);
      })
      .catch((err) => {
        openNotificationWithIcon("error", "Something went Wrong !");
      });
  }, [visible]);

  return (
    <div>
      <Modal
        title="Timeline Modal"
        style={{ minWidth: "800px" }}
        open={visible}
        onCancel={() => setVisible(false)}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
        footer={null}
      >
        <>
          {timelineData ? (
            <Timeline
              mode={"left"}
              style={{
                color: "#fff",
                fontWeight: "600",
                paddingTop: "20px",
                paddingRight: "30px",
              }}
            >
              {timelineData.map((data, index) => {
                return (
                  <Timeline.Item label={data.dt}>
                    <div
                      style={{
                        // backgroundColor: "red",
                        display: "inline-block",
                        marginRight: "10px",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#3b3b3b",
                          display: "flex",
                          justifyContent: "center",
                          padding: "6px",
                          alignItems: "center",
                          borderRadius: "5px",
                        }}
                      >
                        <i
                          className={"fa " + data.icon}
                          //   style={{ marginRight: "10px" }}
                        />
                      </div>
                    </div>
                    <span>{data.msg}</span>
                  </Timeline.Item>
                );
              })}
            </Timeline>
          ) : (
            <></>
          )}
        </>
      </Modal>
    </div>
  );
}

export default TimeLinePopUp;
